const STORAGE_KEY = 'druzhba-favorites'

function readFavorites() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(value) ? value.map(String) : []
  } catch (error) {
    return []
  }
}

function persist(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
  } catch (error) {
    console.warn('Не удалось сохранить избранное', error)
  }
}

export default {
  state: {
    ids: []
  },
  getters: {
    favoriteIds(state) {
      return state.ids
    },
    favoriteCount(state) {
      return state.ids.length
    },
    isFavorite: state => id => state.ids.includes(String(id))
  },
  mutations: {
    SET_FAVORITES(state, ids) {
      state.ids = Array.isArray(ids) ? Array.from(new Set(ids.map(String))) : []
      persist(state.ids)
    },
    TOGGLE_FAVORITE(state, id) {
      const normalized = String(id)
      const index = state.ids.indexOf(normalized)
      if (index === -1) state.ids.push(normalized)
      else state.ids.splice(index, 1)
      state.ids = state.ids.slice()
      persist(state.ids)
    }
  },
  actions: {
    INIT_FAVORITES({ commit }) {
      commit('SET_FAVORITES', readFavorites())
    },
    TOGGLE_FAVORITE({ commit }, id) {
      commit('TOGGLE_FAVORITE', id)
    }
  }
}
